var map = {
	"./anglerfish.png": 2260,
	"./blobfish.png": 2148,
	"./blobfish2.png": 5612,
	"./blobfish3.png": 8501,
	"./burger.png": 8792,
	"./creepytoy.png": 943,
	"./deepseacreature.png": 9311,
	"./energydrink.png": 7477,
	"./gascan.png": 6048,
	"./labsy-ph.png": 5933,
	"./markface.png": 6351,
	"./mitchface.png": 2407,
	"./monkfish.png": 3452,
	"./plasticbag.png": 4493,
	"./severedhand.png": 2748,
	"./sixpackring.png": 2810,
	"./smilingsalamander.png": 9170,
	"./straw.png": 6162,
	"./syringe.png": 2688,
	"./toaster.png": 4667,
	"./vape.png": 4953,
	"./waterbottle.png": 7774,
	"./wrapper.png": 2774
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9181;
module.exports = webpackAsyncContext;